module.exports = __webpack_public_path__ + "static/media/vietato-minorenni.9e68b784.png";